import { render } from "./VoucherServiceParameter.vue?vue&type=template&id=2b39970a&scoped=true"
import script from "./VoucherServiceParameter.vue?vue&type=script&lang=ts"
export * from "./VoucherServiceParameter.vue?vue&type=script&lang=ts"

import "./VoucherServiceParameter.vue?vue&type=style&index=0&id=2b39970a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2b39970a"

export default script